import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import LazyYouTube from "./LazyYouTube";

const About = () => {
  const parallaxRef = useRef<HTMLDivElement>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current && sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const windowH = window.innerHeight;
        if (rect.bottom > 0 && rect.top < windowH) {
          const progress = (windowH - rect.top) / (windowH + rect.height);
          parallaxRef.current.style.transform = `translateY(${(progress - 0.5) * -250}px)`;
        }
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <section id="about" className="py-24 px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-center text-3xl md:text-4xl font-semibold text-primary mb-2">
            Über uns
          </h2>
          <h3 className="text-center text-xl md:text-2xl font-light text-primary/80 mb-12 tracking-[0.2em]">
            Erwachsen Feiern!
          </h3>

          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div className="space-y-6 text-foreground/90 text-lg leading-relaxed">
              <p>
                Der Luther Club ist der Nachtclub in Kaiserslautern für stilvolles Ausgehen 
                in erwachsener Atmosphäre. Genieße exklusive Events, erlesene Drinks und eine 
                einzigartige Club-Atmosphäre im Herzen der Stadt – direkt in der Martin-Luther-Straße 8.
              </p>
              <p>
                Ob Mottopartys, DJ-Nights, Live-Musik, Afterwork-Events oder private Feiern – 
                der Luther Club macht jeden Abend zum besonderen Erlebnis. Erwachsen Feiern 
                und Party in Kaiserslautern, so wie du es verdienst.
              </p>

              <Link
                to="/gallery"
                className="inline-flex items-center gap-2 font-[Montserrat] text-sm tracking-[0.15em] uppercase text-primary hover:text-primary/80 transition-colors group"
              >
                Eindrücke ansehen
                <span className="group-hover:translate-x-1 transition-transform">→</span>
              </Link>

              <div className="border-t border-border pt-6">
                <h4 className="font-[Montserrat] text-sm tracking-[0.2em] uppercase text-primary mb-4">
                  Öffnungszeiten
                </h4>
                <ul className="space-y-2 font-[Montserrat] text-sm text-foreground/80">
                  <li className="flex justify-between max-w-xs">
                    <span>Freitag</span>
                    <span>22:00 – 03:00</span>
                  </li>
                  <li className="flex justify-between max-w-xs">
                    <span>Samstag</span>
                    <span>22:00 – 04:00</span>
                  </li>
                </ul>
                <p className="font-[Montserrat] text-xs text-foreground/50 mt-3 italic">
                  Öffnungszeiten können je nach Event abweichen.
                </p>
              </div>
            </div>

            {/* Video */}
            <div className="aspect-[9/16] max-h-[500px] rounded overflow-hidden border border-border relative">
              <LazyYouTube
                videoId="KsEos_MF0lM"
                title="Luther Club Video"
                className="w-full h-full"
              />
              <div className="absolute inset-0" />
            </div>
          </div>
        </div>
      </section>

      {/* Parallax divider */}
      <div
        ref={sectionRef}
        className="relative h-[400px] md:h-[500px] overflow-hidden border-y border-border/30"
      >
        <div
          ref={parallaxRef}
          className="absolute -inset-[150px] bg-cover bg-center will-change-transform"
          style={{ backgroundImage: "url('/images/parallax-1.webp')" }}
        />
        <div className="absolute inset-0 bg-background/30" />
      </div>
    </>
  );
};

export default About;
